module.exports = __webpack_public_path__ + "static/media/ebilling-logotype-l.9de68027.svg";